import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { resources } from "../../mock";

export const Resources = () => (
  <section id="resources" data-testid="resources-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Insights</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white max-w-2xl">
        Intelligence briefings for decision-makers.
      </h2>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {resources.map((r) => (
          <Link key={r.title} to={`/insights/${r.slug}`}
            data-testid={`resource-card-${r.tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-[#0B1035] border border-white/10 hover:border-white/30 transition-colors group overflow-hidden block">
            <div className="h-48 overflow-hidden">
              <img src={r.img} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">{r.tag}</span>
              <h4 className="mt-3 font-heading text-lg font-medium text-white leading-snug">{r.title}</h4>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-slate-400 group-hover:text-white transition-colors">
                Read briefing <ArrowUpRight className="w-4 h-4" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
